<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-base-evgspuReview',
  components: { PageTable },
}
</script>
